import React from 'react';
import styles from './EventScheduleFooter.module.scss';
import Scrollable from '../../../../elements/Scrollable';
import TodayCategories from './TodayCategories';

function EventScheduleFooter(props) {
    const { eventId, dateFilter } = props;

    return (
        <Scrollable className={styles.EventScheduleFooter}>
            <TodayCategories eventId={eventId} dateFilter={dateFilter} />
        </Scrollable>
    );
}

export default EventScheduleFooter;
